import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { logout, getUser } from '../services/authService';

const AuthStatus = () => {
  const navigate = useNavigate();
  const user = getUser();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  if (!user) return null;
  
  return (
    <Dropdown align="end">
      <Dropdown.Toggle variant="transparent" id="dropdown-auth" className="text-white">
        <i className="bi bi-person-circle me-1"></i>
        {user.name}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item disabled>
          <small className="text-muted">
            {user.email}
            <br />
            Rol: {user.role === 'admin' ? 'Administrador' : 'Usuario'}
          </small>
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={handleLogout}>
          <i className="bi bi-box-arrow-right me-2"></i>
          Cerrar sesión
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AuthStatus; 